import * as Blockv from "../MainBv.js"

export interface VeeWalletState {
	fetchStatus: RequestStatus;
	depositAddress: string;
	vee: string;
	usd: string;
	fqdn: string;
}

const INITIAL_VEE_WALLET_STATE: VeeWalletState = {
	fetchStatus: "",
	depositAddress: "",
	vee: "",
	usd: "",
	fqdn: ""
};

export default (state: VeeWalletState = INITIAL_VEE_WALLET_STATE, action: any): VeeWalletState => {
	switch (action.type) {
		case "CURRENT_USER/LOGGED_OUT": {
			return {...INITIAL_VEE_WALLET_STATE};
		}

		case "VEE_WALLET/GET_WALLET/PENDING": {
			return {
				...state,
				fetchStatus: "pending",
			};
		}

		case "VEE_WALLET/GET_WALLET/SUCCESS": {
			return {
				...state,
				fetchStatus: "success",
				depositAddress: action.data.depositAddress,
				vee: action.data.vee,
				usd: action.data.usd,
				fqdn: action.data.fqdn
			};
		}

		case "VEE_WALLET/GET_WALLET/FAILURE": {
			return {
				...state,
				fetchStatus: "failure",
			};
		}
	}

	return state;
};

export const actions = {
	getUserWallet: () => async dispatch => {
		dispatch({type: "VEE_WALLET/GET_WALLET/PENDING"});

		Blockv.instance.client.request('GET', `/v1/user`, null, true)
			.then(data => {
				return Blockv.instance.client.request('GET', '/v1/publisher/deposits/accounts', null, true)
					.then(accounts => {
						const deposit = (accounts || []).find(account => {
							return account.type == 'deposit'
						});
						return Blockv.instance.client.request('GET', `/v1/user/balance`, null, true)
							.then(balance => {
								let vee = balance.find(item => {
									return item.coin === "vee"
								});
								let usd = balance.find(item => {
									return item.coin === "usd"
								});
								return {
									wallet: {id: deposit && deposit.address || "-- --"},
									vee: vee ? vee.balance : "0",
									usd: usd ? usd.balance : "0",
									fqdn: data.system_properties.pub_fqdn
								}
							})
					})
			})
			.then(data => {
				console.info(data);
				dispatch({
					type: "VEE_WALLET/GET_WALLET/SUCCESS",
					data: {
						depositAddress: data.wallet.id,
						vee: data.vee,
						usd: data.usd,
						fqdn: data.fqdn
					},
				})
			})
			.catch(error => {
				dispatch({type: "VEE_WALLET/GET_WALLET/FAILURE"});
			});

	},
};

// helper to get this reducer's state as a typed value
const veeWalletState = state => state.veeWallet as VeeWalletState;

export const selectors = {
	selectWalletFetchStatus: state => veeWalletState(state).fetchStatus,
	selectWalletDepositAddress: state => veeWalletState(state).depositAddress,
	selectWalletVeeBalance: state => veeWalletState(state).vee,
	selectWalletUsdBalance: state => veeWalletState(state).usd,
	selectWalletFqdn: state => veeWalletState(state).fqdn,
};



// WEBPACK FOOTER //
// ./src/reducers/vee_wallet.ts